/* tslint:disable */
/* eslint-disable */
/**
 * SmartAI BMAW
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  GuidReferenceReadModelPagedList,
  IncludeInformations,
  RoleAssignmentUpdates,
  RoleFilterFieldFilterParameter,
  RoleSortFieldSortingParameter,
  RolesAndAssignmentsReadModel,
  SecurityGroupFilterFieldFilterParameter,
  SecurityGroupSortFieldSortingParameter,
  SmartProblemDetails,
  StringReferenceReadModelPagedList,
  UpdateRoleAssignmentsResponse,
  ValidationProblemDetails,
} from '../models/index';
import {
    GuidReferenceReadModelPagedListFromJSON,
    GuidReferenceReadModelPagedListToJSON,
    IncludeInformationsFromJSON,
    IncludeInformationsToJSON,
    RoleAssignmentUpdatesFromJSON,
    RoleAssignmentUpdatesToJSON,
    RoleFilterFieldFilterParameterFromJSON,
    RoleFilterFieldFilterParameterToJSON,
    RoleSortFieldSortingParameterFromJSON,
    RoleSortFieldSortingParameterToJSON,
    RolesAndAssignmentsReadModelFromJSON,
    RolesAndAssignmentsReadModelToJSON,
    SecurityGroupFilterFieldFilterParameterFromJSON,
    SecurityGroupFilterFieldFilterParameterToJSON,
    SecurityGroupSortFieldSortingParameterFromJSON,
    SecurityGroupSortFieldSortingParameterToJSON,
    SmartProblemDetailsFromJSON,
    SmartProblemDetailsToJSON,
    StringReferenceReadModelPagedListFromJSON,
    StringReferenceReadModelPagedListToJSON,
    UpdateRoleAssignmentsResponseFromJSON,
    UpdateRoleAssignmentsResponseToJSON,
    ValidationProblemDetailsFromJSON,
    ValidationProblemDetailsToJSON,
} from '../models/index';

export interface AppRolesGetActiveRoleAssignmentsRequest {
    pageSize?: number;
    pageIndex?: number;
    filterParameters?: Array<SecurityGroupFilterFieldFilterParameter>;
    sortingParameters?: Array<SecurityGroupSortFieldSortingParameter>;
    includeRoleInformations?: IncludeInformations;
    forceRefresh?: boolean;
}

export interface AppRolesGetAvailableRolesRequest {
    pageSize?: number;
    pageIndex?: number;
    filterParameters?: Array<RoleFilterFieldFilterParameter>;
    sortingParameters?: Array<RoleSortFieldSortingParameter>;
    forceRefresh?: boolean;
}

export interface AppRolesGetAvailableSecurityGroupsRequest {
    pageSize?: number;
    pageIndex?: number;
    filterParameters?: Array<SecurityGroupFilterFieldFilterParameter>;
    sortingParameters?: Array<SecurityGroupSortFieldSortingParameter>;
    forceRefresh?: boolean;
}

export interface AppRolesUpdateRoleAssignmentsPostRequest {
    requestBody?: { [key: string]: RoleAssignmentUpdates; };
}

/**
 * 
 */
export class AppRolesApi extends runtime.BaseAPI {

    /**
     */
    async appRolesGetActiveRoleAssignmentsRaw(requestParameters: AppRolesGetActiveRoleAssignmentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RolesAndAssignmentsReadModel>> {
        const queryParameters: any = {};

        if (requestParameters['pageSize'] != null) {
            queryParameters['PageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['pageIndex'] != null) {
            queryParameters['PageIndex'] = requestParameters['pageIndex'];
        }

        if (requestParameters['filterParameters'] != null) {
            queryParameters['filterParameters'] = requestParameters['filterParameters'];
        }

        if (requestParameters['sortingParameters'] != null) {
            queryParameters['sortingParameters'] = requestParameters['sortingParameters'];
        }

        if (requestParameters['includeRoleInformations'] != null) {
            queryParameters['includeRoleInformations'] = requestParameters['includeRoleInformations'];
        }

        if (requestParameters['forceRefresh'] != null) {
            queryParameters['forceRefresh'] = requestParameters['forceRefresh'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://40740436-0f46-43d8-86f5-e2cb999feec6/access_as_user"]);
        }


        let urlPath = `/api/admin/AppRoles/activeRoleAssignements`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RolesAndAssignmentsReadModelFromJSON(jsonValue));
    }

    /**
     */
    async appRolesGetActiveRoleAssignments(requestParameters: AppRolesGetActiveRoleAssignmentsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RolesAndAssignmentsReadModel> {
        const response = await this.appRolesGetActiveRoleAssignmentsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async appRolesGetAvailableRolesRaw(requestParameters: AppRolesGetAvailableRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GuidReferenceReadModelPagedList>> {
        const queryParameters: any = {};

        if (requestParameters['pageSize'] != null) {
            queryParameters['PageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['pageIndex'] != null) {
            queryParameters['PageIndex'] = requestParameters['pageIndex'];
        }

        if (requestParameters['filterParameters'] != null) {
            queryParameters['filterParameters'] = requestParameters['filterParameters'];
        }

        if (requestParameters['sortingParameters'] != null) {
            queryParameters['sortingParameters'] = requestParameters['sortingParameters'];
        }

        if (requestParameters['forceRefresh'] != null) {
            queryParameters['forceRefresh'] = requestParameters['forceRefresh'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://40740436-0f46-43d8-86f5-e2cb999feec6/access_as_user"]);
        }


        let urlPath = `/api/admin/AppRoles/availableRoles`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GuidReferenceReadModelPagedListFromJSON(jsonValue));
    }

    /**
     */
    async appRolesGetAvailableRoles(requestParameters: AppRolesGetAvailableRolesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GuidReferenceReadModelPagedList> {
        const response = await this.appRolesGetAvailableRolesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async appRolesGetAvailableSecurityGroupsRaw(requestParameters: AppRolesGetAvailableSecurityGroupsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StringReferenceReadModelPagedList>> {
        const queryParameters: any = {};

        if (requestParameters['pageSize'] != null) {
            queryParameters['PageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['pageIndex'] != null) {
            queryParameters['PageIndex'] = requestParameters['pageIndex'];
        }

        if (requestParameters['filterParameters'] != null) {
            queryParameters['filterParameters'] = requestParameters['filterParameters'];
        }

        if (requestParameters['sortingParameters'] != null) {
            queryParameters['sortingParameters'] = requestParameters['sortingParameters'];
        }

        if (requestParameters['forceRefresh'] != null) {
            queryParameters['forceRefresh'] = requestParameters['forceRefresh'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://40740436-0f46-43d8-86f5-e2cb999feec6/access_as_user"]);
        }


        let urlPath = `/api/admin/AppRoles/availableSecurityGroups`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StringReferenceReadModelPagedListFromJSON(jsonValue));
    }

    /**
     */
    async appRolesGetAvailableSecurityGroups(requestParameters: AppRolesGetAvailableSecurityGroupsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StringReferenceReadModelPagedList> {
        const response = await this.appRolesGetAvailableSecurityGroupsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async appRolesUpdateRoleAssignmentsPostRaw(requestParameters: AppRolesUpdateRoleAssignmentsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpdateRoleAssignmentsResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://40740436-0f46-43d8-86f5-e2cb999feec6/access_as_user"]);
        }


        let urlPath = `/api/admin/AppRoles/roleAssignments`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpdateRoleAssignmentsResponseFromJSON(jsonValue));
    }

    /**
     */
    async appRolesUpdateRoleAssignmentsPost(requestParameters: AppRolesUpdateRoleAssignmentsPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpdateRoleAssignmentsResponse> {
        const response = await this.appRolesUpdateRoleAssignmentsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
